import React from 'react'
import RCollapsible from 'react-collapsible'

export default function Collapsible({ ...props }) {
  return <RCollapsible {...props} overflowWhenOpen='visible' />
}
